import React from 'react';

/**
 * EU SDG indicator tag badge (D-2). Shown in EU mode only.
 */
const IndicatorTagBadge = ({ tag }) => {
  if (!tag || tag === 'none') {
    return null;
  }
  const label = tag === 'national' || tag === 'proxy' ? 'National' : null;
  if (!label) {
    return null;
  }
  const className = 'eu-indicator-tag eu-indicator-tag-national';
  return (
    <span className={className} title={`EU SDG ${label.toLowerCase()} indicator`}>
      {label}
    </span>
  );
};

export default IndicatorTagBadge;
